import PublicAvatarImage from "../coach/PublicAvatarImage"
import FreeConsultation from "./FreeConsultation"
import StandardService from "./StandardService"
import ServicePageBadges from "./ServicePageBadges"
import useLoading from "../../hooks/useLoading"
import { Button } from "../ui/button"
import { Link, useParams } from "react-router-dom"
import { PublicProfileRequests } from "../../api/public.service"
import { ServiceRequests } from "../../api/app.service"
import { SvgZoeeLogoGradiant, SvgChevronLeft } from "../icons"
import { useContext, useEffect, useState } from "react"
import { UserCtx } from "../../context/userContext"
import { useNavigate } from "react-router-dom"
import { useToast } from "../../hooks/useToast"

const PublicServicePage = () => {
  const [coachPublicProfileData, setCoachPublicProfileData] =
    useState<any>(null)
  const [service, setService] = useState<any>(null)
  const [servicesLoading, setServicesLoading] = useState<boolean>(false)
  const [cardFieldErrors, setCardFieldErrors] = useState({
    cardName: false,
    cardNumber: false,
    cardExpiry: false,
    cardCvv: false,
  })

  const [allCardFieldsFilled, setAllCardFieldsFilled] = useState(false)

  useEffect(() => {
    const allFilled = Object.values(cardFieldErrors).every(
      (val) => val === false
    )
    setAllCardFieldsFilled(allFilled)
  }, [cardFieldErrors])

  const { startLoading, stopLoading } = useLoading()
  const { toast } = useToast()
  const { service_id, endpoint_slug } = useParams()
  const { user, setUser } = useContext(UserCtx)
  const navigate = useNavigate()
  const coachColor = coachPublicProfileData?.profile_information?.profileColor
  const canBookFreeConsultationAsGuest =
    service?.service_details?.type?.toLowerCase() === "consultation" &&
    Number(service.service_details?.billing?.amount) === 0

  const getCoachPublicProfile = () => {
    if (endpoint_slug) {
      startLoading()
      PublicProfileRequests.getCoachPublicProfile({
        endpoint_slug: endpoint_slug,
      })
        .then((data) => {
          if (data.coach_public_profile) {
            setCoachPublicProfileData(data.coach_public_profile)
            getServices(data)
          } else {
            setCoachPublicProfileData(null)
          }
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  const getProfileServiceList = (coachPublicProfileData: any) => {
    if (user && coachPublicProfileData) {
      setServicesLoading(true)
      const coachProfileId = parseInt(coachPublicProfileData.coach_profile_id)
      const memberProfileId = parseInt(user.activeProfileId)

      ServiceRequests.getServiceListProfile({
        coach_profile_id: coachProfileId,
        member_profile_id: memberProfileId,
      })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response?.data?.message || "An error occurred")
        })
        .finally(() => {
          setServicesLoading(false)
        })
    } else {
      console.warn("User or Coach Public Profile Data is missing.")
    }
  }

  const getServices = (data: any) => {
    ServiceRequests.getServiceListClient({
      profile_id: parseInt(data?.coach_public_profile?.coach_profile_id),
      profile_type: "coach",
    })
      .then((data: any) => {
        stopLoading()
        if (service_id) {
          const service = data?.service_list?.find((service: any) => {
            return (
              service.service_id === parseInt(service_id) &&
              service?.service_details?.status === "active"
            )
          })
          setService(service)
        }
      })
      .catch((ex) => {
        console.error(ex)
        toast.error(ex.response.data.message)
        stopLoading()
      })
  }

  useEffect(() => {
    getCoachPublicProfile()
  }, [])

  return (
    <>
      {coachPublicProfileData && (
        <>
          <div className="w-screen h-screen mx-auto flex flex-col pt-4 md:pt-16 pb-4 md:pb-8 items-center bg-gradient-to-b from-[#292F8F] via-[#4750F5] to-[#8A90FF] overflow-x-hidden ">
            {" "}
            {service ? (
              <>
                <div
                  className={`main-shadow mt-4 w-[90%] rounded-[16px] bg-white border-2 justify-center ${
                    canBookFreeConsultationAsGuest
                      ? "md:w-[75%] md:p-16"
                      : "md:w-[80%] sm:p-10 lg:p-16"
                  }`}
                >
                  {" "}
                  <div className="mt-4 sm:-mt-[15px] px-[20px]">
                    <div className="flex -ml-4">
                      <Button
                        variant="link"
                        onClick={() =>
                          navigate(
                            `/providers/${coachPublicProfileData?.endpoint_slug}/services`
                          )
                        }
                      >
                        <SvgChevronLeft /> Return to services{" "}
                      </Button>{" "}
                    </div>
                    <div className="mb-[20px] flex w-full flex-col justify-between md:mb-[24px]">
                      <div className="flex flex-col gap-[8px] text-4xl font-bold mt-4 md:mt-0">
                        {service?.service_details?.title}
                      </div>
                      <div className="flex items-center gap-4 mt-8">
                        <Link
                          to={`/providers/${coachPublicProfileData?.endpoint_slug}`}
                        >
                          <div className="h-20 w-20 rounded-full overflow-hidden flex-shrink-0 cursor-pointer">
                            <PublicAvatarImage
                              coachPublicProfileData={coachPublicProfileData}
                            />
                          </div>
                        </Link>

                        <div className="flex flex-col">
                          <Link
                            to={`/providers/${coachPublicProfileData?.endpoint_slug}`}
                          >
                            <span className="text-2xl font-semibold text-blurple hover:underline cursor-pointer">
                              {coachPublicProfileData?.first_name}{" "}
                              {coachPublicProfileData?.last_name}
                            </span>
                          </Link>
                          <span className="text-lg italic text-graySlate">
                            {coachPublicProfileData?.profile_information.title}
                          </span>
                        </div>
                      </div>
                    </div>

                    {canBookFreeConsultationAsGuest ? (
                      <div className="">
                        <FreeConsultation
                          service={service}
                          coachPublicProfileData={coachPublicProfileData}
                          canBookFreeConsultationAsGuest={
                            canBookFreeConsultationAsGuest
                          }
                          coachColor={coachColor}
                          getProfileServiceList={getProfileServiceList}
                        />
                      </div>
                    ) : (
                      <div className="">
                        <div className="flex gap-4 items-center mb-4">
                          <ServicePageBadges service={service} />
                        </div>
                        <div className="">
                          <StandardService
                            service={service}
                            coachPublicProfileData={coachPublicProfileData}
                            cardFieldErrors={cardFieldErrors}
                            setCardFieldErrors={setCardFieldErrors}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="fixed inset-0 flex min-h-screen flex-col items-center justify-center gap-4">
                <h1 className="text-xl font-bold">Service not found</h1>
                <Button size="lg" asChild>
                  <Link to={`/providers/${endpoint_slug}`}>
                    Back to coach
                  </Link>
                </Button>
              </div>
            )}
            <div className="mt-8 inline-flex items-center gap-2 text-base">
              <span className="text-white text-lg">Powered by</span>
              <a
                href={process.env.REACT_APP_BASE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="h-[2em] w-auto"
              >
                <SvgZoeeLogoGradiant className="h-full w-auto cursor-pointer" />
              </a>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default PublicServicePage
